export enum AppRoutePath { // ToDo: All routes should be here
  CAMPAIGNS = 'campaigns',
  CAMPAIGNS_LINE_ITEMS = 'line-items',
  CAMPAIGNS_CREATIVE_LIBRARY = 'creative-library',
  ANALYTICS = 'analytics',
  ANALYTICS_PACING = 'pacing',
  CREATIVE_DESIGNER ='creative-designer',
  TARGETING = 'targeting',
  TARGETING_NEW = 'new',
  TARGETING_EDIT = 'edit',
  ERRORS = 'errors',
}
